var ChannelType;
(function (ChannelType) {
    ChannelType["WebhookChannel2023"] = "http://www.w3.org/ns/solid/notifications#WebhookChannel2023";
    ChannelType["WebSocketChannel2023"] = "http://www.w3.org/ns/solid/notifications#WebSocketChannel2023";
})(ChannelType || (ChannelType = {}));

export { ChannelType };
//# sourceMappingURL=index.mjs.map
